// extracted by mini-css-extract-plugin
module.exports = {"ListAgreement":"ListAgreements_ListAgreement__jXJ0w"};